import React, { useState, useEffect} from 'react';
import { useSpring, a, config } from '@react-spring/web';
import styles from './flip-card.module.css';

const FlipCard = (props) =>
{
    const [flipped, set] = useState(false)
    const { transform, opacity } = useSpring({
      opacity: flipped ? 1 : 0,
      transform: `rotateX(${flipped ? 180 : 0}deg) translate(0, 0)`,
      //`perspective(600px) rotateX(${flipped ? 180 : 0}deg) translate(-50%, 0)`,
      //config: { mass: 5, tension: 500, friction: 80 },
      config:config.wobbly
    })

    useEffect(()=>
    {
        set(props.flipped);
    }, [props.flipped])

    return (
      <div className={styles.container} 
        //onClick={() => set(state => !state)}
      >       
        <a.div
          className={`${styles.c} ${styles.front}`}
          style={{
            opacity,
            transform,
            rotateX: '180deg',
            display:'block',
            ...props.style
          }}
        >{props.front}</a.div>
        <a.div
          className={`${styles.c} ${styles.back}`}
          style={{ opacity: opacity.to(o => 1 - o), transform , display:'block',...props.style}}
        >{props.back}</a.div>
      </div>
    )
}

export default FlipCard;